import { useState } from "react";
import SidebarBody from "./SidebarBody";
import LeftSidebarHeader from "./SidebarHeader";

const LeftSidebar = () => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <div
      className={`w-full h-full border-r sm:absolute md:relative bg-white z-10 ${
        open ? "sm:left-0 md:left-0" : "sm:-left-full md:left-0"
      }`}
    >
      <button
        onClick={() => setOpen(!open)}
        className={`bg-slate-500 absolute sm:block md:hidden ${
          open ? "sm:right-2" : "sm:left-full"
        } w-7 h-7 rounded-sm top-[65px]`}
      >
        {open ? (
          <i className="fa-solid fa-caret-left text-white"></i>
        ) : (
          <i className="fa-solid fa-caret-right text-white"></i>
        )}
      </button>
      <LeftSidebarHeader />
      <SidebarBody />
    </div>
  );
};

export default LeftSidebar;
